module.exports = __webpack_public_path__ + "static/media/hbar_symbol_circle_white.d40cfcca.svg";